"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    get: function() {
        return get;
    },
    modify: function() {
        return modify;
    }
});
const _enums = require("../../enums");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function get(imageInfo = {}) {
    var _imageInfo_ImageInfoKeys_IRVIEWER;
    return (_imageInfo_ImageInfoKeys_IRVIEWER = imageInfo[_enums.ImageInfoKeys.IRVIEWER]) !== null && _imageInfo_ImageInfoKeys_IRVIEWER !== void 0 ? _imageInfo_ImageInfoKeys_IRVIEWER : {};
}
function modify(key = "", value = {}, imageInfo = {}) {
    let nextIRVIEWER = {};
    const IRVIEWER = get(imageInfo);
    if (Object.keys(value).length > 0 && Object.values(_enums.IRViewerKeys).includes(key)) {
        nextIRVIEWER = _object_spread_props(_object_spread({}, IRVIEWER), {
            [key]: _object_spread({}, IRVIEWER === null || IRVIEWER === void 0 ? void 0 : IRVIEWER[key], value)
        });
    }
    return nextIRVIEWER;
}
const irviewerHandler = {
    get,
    modify
};
const _default = irviewerHandler;
